import { createContext } from "react"

export const CollapsibleCtx = createContext<{ expanded: boolean }>(undefined!)
